<template>
    <div class="routing-addresses-empty">
        <CompassEmptyState
            illustrationPath="/ressources/logged/img/illustrations/pdp/empty-contact-create-white.svg"
            :title="translations.title"
            :caption="translations.caption"
        >
            <CompassButton
                :label="translations.action"
                :type="CompassEnums.ButtonType.PRIMARY"
                @click="onCompleteCompany"
            />
        </CompassEmptyState>
    </div>
</template>

<script setup lang="ts">
import { inject } from 'vue';
import type { Translator } from 'js/shims-vue';

const $t = inject('$t') as Translator;

const translations: Record<string, string> = {
    title: $t.__('overview.tabs.TabRoutingAddresses.empty_state.title'),
    caption: $t.__('overview.tabs.TabRoutingAddresses.empty_state.no_siren.subtitle'),
    action: $t.__('overview.tabs.TabRoutingAddresses.empty_state.no_siren.action'),
};

const onCompleteCompany = (): void => {
    // TODO(SAAS-32515): wire up the "Compléter la fiche société" action once backend is available
};
</script>

<style lang="scss" scoped>
.routing-addresses-empty {
    margin-top: var(--spacing-4);
}
</style>
